export const NAME = 'shrinkWrappingCategories';